import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { CrudGenericsService } from '../common/crud-generics';
import { Environment, ModelGuid, ModelStr, NotificheRegistroPersone } from '../../models/-index';
import { Observable } from 'rxjs';

@Injectable()
export class NotificheRegistroPersoneService extends CrudGenericsService<NotificheRegistroPersone, number> {
  private base: string;

  constructor(protected http: HttpClient, @Inject('ENV') env: Environment) {
    super(http, `${env.apiUrl}/api/NotificheRegistroPersone`);
    this.base = `${env.apiUrl}/api/NotificheRegistroPersone/`;
  }
  // set data lettura 1 elemento
  SetDtLettura_ByIdMsg(id: string): Observable<void> {
    const model: ModelGuid = { Value: id };
    const url = this.base + 'SetDtLettura_ByIdMsg';
    return this.http.post<void>(`${url}`, model);
  }
  // set data lettura + elementi
  SetDtLettura_AllMsg(model: ModelGuid[]): Observable<void> {
    const url = this.base + 'SetDtLettura_AllMsg';
    return this.http.post<void>(`${url}`, model);
  }
  // ionic modello FCM
  IonGetNotificheNotReaded_ByNotInList(model: ModelStr[], piattaforma: string): Observable<any[]> {
    const url = this.base + 'IonGetNotificheNotReaded_ByNotInList?piattaforma=' + piattaforma;
    return this.http.post<any[]>(`${url}`, model);
  }
  // web modello FCM
  WebGetNotificheNotReaded_ByNotInList(model: ModelStr[], piattaforma: string): Observable<any[]> {
    const url = this.base + 'WebGetNotificheNotReaded_ByNotInList?piattaforma=' + piattaforma;
    return this.http.post<any[]>(`${url}`, model);
  }
}
